import { InterventionTag } from '@/types';
import { Select, Text, Inline, InlineItem, Icon } from '@kinesis/bungle';

const tagOptions = [
  { value: 'current', label: 'Current', color: '#6FB6C5' },
  { value: 'intermediate', label: 'Intermediate', color: '#2D4F75' },
  { value: 'aggressive', label: 'Aggressive', color: '#6FC58B' },
];

const renderTagLabel = (item: any) => {
  return (
    <Inline>
      <InlineItem sizing='fit-content'>
        <Icon color={item.color} magnitude='small' type='circle' />
      </InlineItem>
      <InlineItem sizing='fill-container'>
        <Text>{item.label}</Text>
      </InlineItem>
    </Inline>
  );
};

const TagSelect = (props: TagSelectProps) => {
  const { value, onChange } = props;
  return (
    <Select
      magnitude='large'
      options={tagOptions}
      value={value}
      renderItem={renderTagLabel}
      onChange={onChange}
    />
  );
};

export type TagSelectProps = {
  value: InterventionTag;
  onChange: (v: InterventionTag) => void;
};

export { TagSelect, tagOptions, renderTagLabel };
